<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <b-row v-if="!loading">
            <b-col cols="12" md="12">
                <component-header
                    :title="`Edit Product - ${itemObj.description_summary || itemObj.Name || ''}`"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="backNavigate"
                />
            </b-col>
            <b-col cols="12" sm="12">
                <b-card>
                    <div>
                        <b-card>
                            <b-row class="ml-5">
                                <b-col
                                    cols="12"
                                    sm="4"
                                    @click="() => showImagePicker('icon')"
                                >
                                    <b-form-group
                                        label="Icon"
                                        label-for="Icon"
                                        :label-cols="7"
                                    ></b-form-group>
                                    <single-image
                                        height="210px"
                                        width="180px"
                                        v-if="iconImagedata"
                                        :url="
                                            itemObj.product_summary.images.icon
                                        "
                                        label="Browse for Icon"
                                    ></single-image>
                                </b-col>
                                <b-col
                                    sm="4"
                                    @click="() => showImagePicker('smallImage')"
                                >
                                    <b-form-group
                                        label="Small Image"
                                        label-for="SmallImage"
                                        :label-cols="7"
                                        :horizontal="true"
                                    ></b-form-group>
                                    <single-image
                                        height="200px"
                                        width="180px"
                                        v-if="smallImagedata"
                                        :url="
                                            itemObj.product_summary.images
                                                .smallImage
                                        "
                                        label="Browse Small Image"
                                    ></single-image>
                                </b-col>
                                <b-col
                                    sm="4"
                                    @click="() => showImagePicker('bigImage')"
                                >
                                    <b-form-group
                                        label="Big Image"
                                        label-for="BigImage"
                                        :label-cols="7"
                                        :horizontal="true"
                                    ></b-form-group>
                                    <single-image
                                        height="200px"
                                        width="180px"
                                        v-if="landingImagedata"
                                        :url="
                                            itemObj.product_summary.images
                                                .bigImage
                                        "
                                        label="Browse for Big Image"
                                    ></single-image>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-modal
                            v-model="showImageSelector"
                            centered
                            scrollable
                            size="lg"
                        >
                            <div class="p-2">
                                <b-row>
                                    <div class="md-3">
                                        <v-switch
                                            class="pa-2"
                                            color="blue"
                                            v-model="showLibrary"
                                        ></v-switch>
                                        <span class="mr-2 mb-1"
                                            >Pick From Library</span
                                        >
                                    </div>
                                    <div
                                        class="md-3 ml-auto"
                                        v-if="!showLibrary"
                                    >
                                        <b-button
                                            @click="$refs.imageUploader.click()"
                                            >Select and Upload New</b-button
                                        >
                                        <input
                                            class="d-none"
                                            ref="imageUploader"
                                            type="file"
                                            @change="uploadImageFromSelector"
                                        />
                                    </div>
                                </b-row>
                                <b-row
                                    v-if="showLibrary"
                                    class="max-height-400 overflow-x-auto text-center"
                                >
                                    <b-col
                                        v-for="(d, i) in imageLibraryList"
                                        :key="i"
                                        md="2"
                                        @click="setImageFromLibrary(d.images)"
                                    >
                                        <img
                                            :src="
                                                d.images[libraryImageSelector]
                                            "
                                            class="object-fit-contain"
                                            height="100px"
                                            width="100%"
                                        />
                                        {{ d.title }}
                                    </b-col>
                                </b-row>
                            </div>
                        </b-modal>
                    </div>
                    <div
                        v-for="(entry, idx) in attributesMap.entries()"
                        :key="idx"
                    >
                        <b-row>
                            <b-col
                                v-for="(item, index) in entry[1]"
                                :key="index"
                                :md="['Array'].includes(item.type) ? 12 : 6"
                                :style="{
                                    display:
                                        item.type !== 'Array' ||
                                        (item.type === 'Array' &&
                                            valuesMap[item.name] &&
                                            valuesMap[item.name][0])
                                            ? 'block'
                                            : 'none',
                                }"
                            >
                                <field
                                    v-if="
                                        item.name !== 'days' &&
                                        item.name !== 'Type' &&
                                        item.name !== 'IsSellable' &&
                                        item.name !== 'b2bType'
                                    "
                                    :fieldType="item.type"
                                    :fieldName="item.name"
                                    :displayName="
                                        item.attributeLabel &&
                                        item.attributeLabel[tenantLang]
                                            ? item.attributeLabel[tenantLang]
                                            : item.name
                                    "
                                    :onChange="fieldChange"
                                    :value="valuesMap[item.name]"
                                    :id="item._id"
                                    :isRequired="item.isRequired"
                                    :subFields="item.attributeItems"
                                    :level="0"
                                    :meta="[
                                        { name: item.name, type: item.type },
                                    ]"
                                    :active="activeIndex"
                                    :index="index"
                                    :setActive="setActive"
                                    :UIConcern="item.UIConcern"
                                    :enumValues="item.enumValues"
                                    :arrayChange="arrayChange"
                                    :valuesMap="valuesMap"
                                    :visibility="
                                        item.visibility
                                            ? item.visibility.onUpdate
                                            : true
                                    "
                                />
                                <b-col v-if="item.name === 'IsSellable'">
                                    <v-switch
                                        color="indigo"
                                        v-model="inputObj['IsSellable']"
                                        :label="`IsSellable`"
                                    ></v-switch>
                                </b-col>
                                <card v-if="item.name === 'b2bType'">
                                    <label class="card-title">{{
                                        item.name
                                    }}</label>
                                    <b-col class="pb-1">
                                        <eb-select
                                            type="text"
                                            :id="'b2bType'"
                                            v-model="typeB2b"
                                            :options="selectB2b"
                                            :selected="typeB2b"
                                            label="text"
                                            placeholder="Select b2b Type"
                                        ></eb-select>
                                    </b-col>
                                </card>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="isAddresscapture">
                        <b-row>
                            <b-col>
                                <Card>
                                    <div class="wrap">
                                        <b-form-group>
                                            <p class="head">Location</p>
                                            <GmapAutocomplete
                                                @place_changed="placechange"
                                                :placeholder="
                                                    locationplaceholder
                                                "
                                                class="mt-1 location-search"
                                                :options="{
                                                    fields: [
                                                        'geometry',
                                                        'formatted_address',
                                                        'address_components',
                                                    ],
                                                }"
                                                @focus="
                                                    locationplaceholder =
                                                        'Enter New Location'
                                                "
                                                @blur="
                                                    locationplaceholder =
                                                        itemObj.Address.Address
                                                "
                                            ></GmapAutocomplete>
                                        </b-form-group>
                                    </div>
                                </Card>
                            </b-col>
                        </b-row>
                    </div>
                    <div
                        v-if="
                            catalogObj &&
                            catalogObj.variations &&
                            catalogObj.variations.length > 0 &&
                            itemObj.productType === 'VARIABLE'
                        "
                    >
                        <a-divider />
                        <Variance
                            :isService="isService"
                            :varianceData="catalogVariations"
                            :variableDetails="itemObj.variations"
                            @change="onchangeVarianceData"
                            @changeDefault="changeDefault"
                        />
                    </div>
                    <a-divider />
                    <div class="form-actions text-center" v-if="!submitted">
                        <button
                            class="mr-1 btn btn-primary"
                            variant="facebook"
                            @click="handleSumit"
                        >
                            <span>Update Item</span>
                        </button>
                        <router-link to="/item">
                            <button
                                class="mr-1 btn btn-danger"
                                variant="danger"
                            >
                                <span>Cancel</span>
                            </button>
                        </router-link>
                    </div>
                    <div class="form-action text-center" v-else>
                        <v-progress-circular
                            :indeterminate="true"
                            color="light-blue"
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<style scoped>
.flex-row {
    display: flex;
}
</style>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import cTable from "@/views/base/Table.vue";
import Field from "@/components/Item/Field";
import Card from "@/components/Generics/Card.vue";
import Variance from "@/components/Variance/Variance.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import Vue from "vue";
import SingleImage from "@/components/Common/Image.vue";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage";
import locationMixins from "@/mixins/addressLocation";
import { BUCKET_BASEURL, GATEWAY_BASEURL } from "@/services/index";
import { mapGetters, mapActions } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "createItem",
    dark: {
        type: Boolean,
        default: false,
    },
    components: {
        cSwitch,
        cTable,
        Card,
        field: Field,
        SingleImage,
        Variance,
        ebSelect,
        VueUploadMultipleImage,
        ComponentHeader,
        AtomSpinner,
    },
    mixins: [locationMixins],
    data() {
        return {
            typeB2b: {},
            isAddresscapture: false,
            locationplaceholder: "",
            catalogObj: null,
            iconImagedata: null,
            smallImagedata: null,
            landingImagedata: null,
            libraryImageSelector: "",
            showImageSelector: false,
            showLibrary: false,
            alternateImages: [],
            itemObj: {},
            inputObj: {
                Name: "",
                description_summary: "",
                provider: null,
                catalogId: "",
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                    alternateImages: [],
                },
            },
            externalAttribute: [],
            attributesMap: new Map(),
            valuesMap: {},
            activeIndex: null,
            submitted: false,
            loading: false,
        };
    },
    props: {
        context: {
            type: String,
        },
    },
    computed: {
        ...mapGetters({
            tenantLang: "tenant/GetTenantLanguage",
            imageLibraryList: "catalog/GetImageLibraryList",
            partnerAllData: "partner/GetPartnerData",
        }),
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        selectB2b() {
            return [
                {
                    text: "Sell to Customer",
                    value: 0,
                },
                {
                    text: "Sell to Merchant",
                    value: 1,
                },
                {
                    text: "Sell to Both",
                    value: 2,
                },
            ];
        },
        addressObj() {
            return this.$store.getters["item/GetCurrentCatalogLocation"];
        },
        isService() {
            if (
                this.catalogObj &&
                this.catalogObj.variations &&
                this.catalogObj.variations.length > 0 &&
                this.catalogObj.variations.some(
                    (obj) => obj.attrRef.attributeName === "slotTitle",
                )
            ) {
                return true;
            } else {
                return false;
            }
        },
        catalogVariations() {
            if (
                this.catalogObj &&
                this.catalogObj.variations &&
                this.catalogObj.variations.length > 0
            ) {
                let objj = this.catalogObj.variations.filter((obj) => {
                    if (obj.attrRef.attributeName === "Quantity") {
                        return obj;
                    }
                });
                return objj;
            }
            return [];
        },
    },
    methods: {
        getDefaultItemObject() {
            return {
                Name: "",
                description_summary: "",
                catalogId: "",
                provider: null,
                productType: "NORMAL",
                b2bType: 0,
                product_summary: {
                    images: {
                        icon: "",
                        smallImage: "",
                        bigImage: "",
                    },
                },
                attributeItems: [],
                string_attributes: [],
                integer_attributes: [],
                Address: {},
            };
        },
        async loadItem() {
            await this.$store.dispatch(
                "item/fetchItemById",
                this.$route.params.id,
            );
            const itemData = this.$store.getters["item/GetCurrentItemObject"];
            const responsePayload = itemData && itemData.response;
            const fetchedItem =
                responsePayload && Array.isArray(responsePayload)
                    ? responsePayload[0] || null
                    : responsePayload && typeof responsePayload === "object"
                      ? responsePayload
                      : null;
            this.itemObj = fetchedItem
                ? {
                      ...this.getDefaultItemObject(),
                      ...fetchedItem,
                      product_summary: {
                          ...this.getDefaultItemObject().product_summary,
                          ...(fetchedItem.product_summary || {}),
                          images: {
                              ...this.getDefaultItemObject().product_summary
                                  .images,
                              ...((fetchedItem.product_summary || {}).images ||
                                  {}),
                          },
                      },
                  }
                : this.getDefaultItemObject();

            this.initializeItemState();
            await this.loadImages();
            this.buildAttributeMaps();
            await this.loadVariationMetadata();
        },
        initializeItemState() {
            if (!this.itemObj || typeof this.itemObj !== "object") {
                this.itemObj = this.getDefaultItemObject();
            }
            if (this.itemObj.hasOwnProperty("IsSellable")) {
                this.inputObj["IsSellable"] =
                    this.itemObj.IsSellable === "TRUE";
            }
            this.typeB2b =
                this.selectB2b.find(
                    (sellTo) => sellTo.value == this.itemObj.b2bType,
                ) || {};
            this.inputObj.catalogId = this.itemObj.catalogId;
            if (this.itemObj.Name) {
                this.inputObj.Name = this.itemObj.Name;
                this.inputObj.description_summary = this.itemObj.Name;
            }
            const commonFields = [
                "Price",
                "Discount",
                "Discount(%)",
                "Deal Price",
            ];
            commonFields.forEach((field) => {
                if (
                    this.itemObj.hasOwnProperty(field) &&
                    this.itemObj[field] !== undefined
                ) {
                    this.inputObj[field] = this.itemObj[field];
                }
            });
        },
        buildAttributeMaps() {
            const allowedTypes = new Set([
                "String",
                "Number",
                "Object",
                "Array",
                "Boolean",
            ]);
            const attributesMap = new Map([
                ["String", []],
                ["Number", []],
                ["Object", []],
                ["Array", []],
                ["Boolean", []],
            ]);
            const valuesMap = { ...this.itemObj };
            const addressAttributes = new Set([
                "Address",
                "State",
                "Country",
                "City",
                "Area",
                "Lat",
                "Lng",
            ]);
            if (
                !this.itemObj.attributeItems ||
                !Array.isArray(this.itemObj.attributeItems)
            ) {
                this.attributesMap = attributesMap;
                this.valuesMap = valuesMap;
                this.syncValuesMapToInputObj();
                return;
            }

            this.itemObj.attributeItems.forEach((item) => {
                if (!item || addressAttributes.has(item.attributeName)) {
                    if (item && item.attributeName === "Address") {
                        this.isAddresscapture = true;
                        this.locationplaceholder = this.itemObj.Address.Address;
                    }
                    return;
                }

                const attributeType = item.attributeValueType;
                const attributeName = item.attributeName;

                if (!allowedTypes.has(attributeType)) {
                    return;
                }

                const attributeObject = {
                    ...item,
                    type: attributeType,
                    name: attributeName,
                };
                attributesMap.set(attributeType, [
                    ...attributesMap.get(attributeType),
                    attributeObject,
                ]);
                this.processAttributeValue(
                    valuesMap,
                    attributeObject,
                    attributeType,
                    attributeName,
                );
            });
            Object.keys(this.itemObj).forEach((key) => {
                if (
                    key !== "attributeItems" &&
                    key !== "string_attributes" &&
                    key !== "integer_attributes" &&
                    !Array.isArray(this.itemObj[key]) &&
                    typeof this.itemObj[key] !== "object"
                ) {
                    if (
                        !valuesMap.hasOwnProperty(key) ||
                        valuesMap[key] === undefined
                    ) {
                        valuesMap[key] = this.itemObj[key];
                    }
                }
            });

            this.attributesMap = attributesMap;
            this.valuesMap = valuesMap;
            this.syncValuesMapToInputObj();
        },
        syncValuesMapToInputObj() {
            if (this.valuesMap.Name && !this.inputObj.Name) {
                this.inputObj.Name = this.valuesMap.Name;
                this.inputObj.description_summary = this.valuesMap.Name;
            }
            const priceFields = [
                "Price",
                "Discount",
                "Discount(%)",
                "Deal Price",
            ];
            priceFields.forEach((field) => {
                if (
                    this.valuesMap.hasOwnProperty(field) &&
                    this.valuesMap[field] !== undefined
                ) {
                    this.inputObj[field] = this.valuesMap[field];
                }
            });
        },
        processAttributeValue(valuesMap, attributeObj, type, name) {
            if (type === "Array") {
                this.processArrayAttribute(valuesMap, attributeObj, name);
            } else if (["Number", "String"].includes(type)) {
                this.processPrimitiveAttribute(valuesMap, name, type);
            }
        },
        processArrayAttribute(valuesMap, attributeObj, name) {
            const existingValue = valuesMap[name];

            if (attributeObj.UIConcern === "Select") {
                if (Array.isArray(existingValue) && existingValue.length > 0) {
                    const optionsMap = new Map(
                        attributeObj.attributeItems.map((a) => [
                            a._id,
                            {
                                label: a.attributeName,
                                value: a._id,
                            },
                        ]),
                    );
                    valuesMap[name] = existingValue.map((o) =>
                        optionsMap.get(o),
                    );
                }
            } else if (attributeObj.UIConcern === "Object") {
                if (existingValue === undefined || existingValue === null) {
                } else {
                    valuesMap[name] = existingValue;
                }
            } else if (attributeObj.UIConcern === "Checkbox") {
                if (existingValue === undefined || existingValue === null) {
                } else {
                    valuesMap[name] = existingValue;
                }
            }
        },
        processPrimitiveAttribute(valuesMap, attributeName, attributeType) {
            const attributeSource = {
                Number: "integer_attributes",
                String: "string_attributes",
            };

            const sourceArray = this.itemObj[attributeSource[attributeType]];
            if (!sourceArray) {
                return;
            }
            const valueItem = sourceArray.find(
                (pair) => pair.attribute_name === attributeName,
            );
            if (valueItem) {
                valuesMap[attributeName] = valueItem.attribute_value;
            }
        },
        async loadVariationMetadata() {
            console.log(this.inputObj,"inputObj");
            await this.$store
                .dispatch("catalog/fetchCatalogById", this.inputObj.catalogId)
                .then((result) => {
                    if (result.status !== 0) {
                        this.catalogObj = result.response;
                        this.buildExternalAttributesMap(result.response);
                    }
                });
        },
        buildExternalAttributesMap(catalogResponse) {
            const allowedTypes = new Set([
                "String",
                "Number",
                "Object",
                "Array",
                "Boolean",
            ]);

            const defaultStringAttributes = [
                {
                    type: "String",
                    name: "Title",
                    _id: "9",
                },
            ];
            const attributesMap = new Map(this.attributesMap);
            const existingStringAttrs = attributesMap.get("String") || [];
            const hasTitle = existingStringAttrs.some(
                (attr) => attr.name === "Title",
            );
            if (!hasTitle) {
                attributesMap.set("String", [
                    ...existingStringAttrs,
                    ...defaultStringAttributes,
                ]);
            }
            const valuesMap = { ...this.valuesMap };
            if (!valuesMap.hasOwnProperty("Title")) {
                valuesMap.Title = "";
            }

            catalogResponse.externalAttributes.forEach((item) => {
                if (!item.attributeRef) return;

                const attributeType = item.attributeRef.attributeValueType;
                const attributeName = item.attributeRef.attributeName;

                if (!allowedTypes.has(attributeType)) return;
                const existingAttrs = attributesMap.get(attributeType) || [];
                const attributeExists = existingAttrs.some(
                    (attr) =>
                        attr.attributeName === attributeName ||
                        attr.name === attributeName,
                );
                if (attributeExists) return;

                const attributeObject = {
                    ...item,
                    ...item.attributeRef,
                    type: attributeType,
                    name: attributeName,
                };

                attributesMap.set(attributeType, [
                    ...attributesMap.get(attributeType),
                    attributeObject,
                ]);
                this.initializeExternalAttributeValue(
                    valuesMap,
                    attributeObject,
                    attributeType,
                    attributeName,
                );
            });

            this.attributesMap = attributesMap;
            this.valuesMap = valuesMap;
            this.syncValuesMapToInputObj();
        },
        initializeExternalAttributeValue(valuesMap, attributeObj, type, name) {
            if (
                valuesMap.hasOwnProperty(name) &&
                valuesMap[name] !== undefined &&
                valuesMap[name] !== null
            ) {
                return;
            }

            if (["String", "Number"].includes(type)) {
                valuesMap[name] = "";
            } else if (type === "Boolean") {
                valuesMap[name] = false;
                if (!this.inputObj.hasOwnProperty(name)) {
                    this.inputObj[name] = false;
                }
            } else if (type === "Object") {
                valuesMap[name] = {};
            } else if (type === "Array") {
                this.initializeArrayAttributeValue(
                    valuesMap,
                    attributeObj,
                    name,
                );
            }
        },
        initializeArrayAttributeValue(valuesMap, attributeObj, name) {
            if (["Checkbox"].includes(attributeObj.UIConcern)) {
                valuesMap[name] = attributeObj.attributeItems;
            } else if (attributeObj.UIConcern === "Radio") {
                valuesMap[name] = null;
            } else if (attributeObj.UIConcern === "Select") {
                valuesMap[name] = [];
            } else if (attributeObj.UIConcern === "Object") {
                const defaultObject = {};
                attributeObj.attributeItems.forEach((item) => {
                    defaultObject[item.attributeName] = "";
                });
                valuesMap[name] = [defaultObject];
            }
        },
        async loadImages() {
            this.iconImagedata = await this.getResizedImageUrl(
                this.itemObj.product_summary.images.icon,
            );
            this.smallImagedata = await this.getResizedImageUrl(
                this.itemObj.product_summary.images.smallImage,
            );
            this.landingImagedata = await this.getResizedImageUrl(
                this.itemObj.product_summary.images.bigImage,
            );
        },
        extractImageKey(imageURL) {
            return imageURL.replace(BUCKET_BASEURL, "");
        },
        async getResizedImageUrl(imageURL) {
            if (!imageURL) return null;
            const imageKey = this.extractImageKey(imageURL);
            return `${GATEWAY_BASEURL}/resize/index.php?width=300&height=250&quality=100&name=${imageKey}`;
        },
        async uploadImage(imageType, imageData) {
            this.showImageSelector = false;

            const uploadData = {
                image: imageData,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["seller", "items"],
            };

            this.showCustomToast();

            try {
                const result = await this.$store.dispatch(
                    "inventory/uploadImageToStorage",
                    uploadData,
                );

                if (result) {
                    this.clearCustomToast();
                    const imageUrl = result.data.fileUrl;
                    this.updateItemImage(imageType, imageUrl);
                }
            } catch (error) {
                this.clearCustomToast();
                this.$toasted.error("Image not uploaded..please try again!");
            }
        },
        updateItemImage(imageType, imageUrl) {
            const imagePropertyMap = {
                icon: "icon",
                smallImage: "smallImage",
                smallimage: "smallImage",
                largeimage: "bigImage",
            };

            const property = imagePropertyMap[imageType] || "bigImage";
            this.itemObj.product_summary.images[property] = imageUrl;
        },
        getAttributeTypeByName(attributeName) {
            if (!this.attributesMap) return null;

            for (const [type, attributes] of this.attributesMap.entries()) {
                const found = attributes.find(
                    (attr) => attr.attributeName === attributeName,
                );
                if (found) return type;
            }

            return null;
        },
        convertToAttrType(value, attrType) {
            if (typeof value === "undefined" || value === null) return value;
            if (!attrType) return value;

            try {
                if (attrType === "String") return value.toString();
                if (attrType === "Number") {
                    return typeof value === "number" ? value : Number(value);
                }
                if (attrType === "Boolean") return Boolean(value);
                return value;
            } catch (e) {
                return value;
            }
        },
        getAttributeValue(attributeName) {
            if (this.itemObj.hasOwnProperty(attributeName)) {
                return this.itemObj[attributeName];
            }
            const stringAttr = this.itemObj.string_attributes?.find(
                (attr) => attr.attribute_name === attributeName,
            );
            if (stringAttr) return stringAttr.attribute_value;
            const integerAttr = this.itemObj.integer_attributes?.find(
                (attr) => attr.attribute_name === attributeName,
            );
            if (integerAttr) return integerAttr.attribute_value;

            return null;
        },
        fieldChange(data) {
            const { meta, value } = data;
            const { name, type } = meta[0];

            if (name === "Name") {
                this.handleNameChange(value);
            } else {
                this.handleAttributeChange(name, type, value);
                this.syncAttributeValueToVariations(name, value);
            }
            this.handlePriceCalculations(data);
        },
        syncAttributeValueToVariations(fieldName, fieldValue) {
            if (
                !this.inputObj.variations ||
                !Array.isArray(this.inputObj.variations) ||
                this.inputObj.variations.length === 0
            ) {
                return;
            }
            this.inputObj.variations.forEach((variant) => {
                if (!variant || !variant.attributes) return;
                variant.attributes[fieldName] = fieldValue;
            });
        },
        handleNameChange(value) {
            this.inputObj.Name = value;
            this.inputObj.description_summary = value;
            this.valuesMap.Name = value;
            this.valuesMap.description_summary = value;
        },
        handleAttributeChange(attributeName, attributeType, value) {
            let processedValue = value;

            if (attributeType === "String" && attributeName !== "Title") {
                this.inputObj[attributeName] = processedValue;
                this.valuesMap[attributeName] = processedValue;
            } else if (attributeType === "Number") {
                processedValue =
                    typeof value === "string" ? Number(value) : value;
                this.inputObj[attributeName] = processedValue;
                this.valuesMap[attributeName] = processedValue;
            } else if (["Boolean", "Object"].includes(attributeType)) {
                this.inputObj[attributeName] = processedValue;
                this.valuesMap[attributeName] = processedValue;
            } else if (attributeType === "Array") {
                this.inputObj[attributeName] = processedValue;
                this.valuesMap[attributeName] = processedValue;
            }
        },
        handlePriceCalculations(data) {
            const { meta } = data;
            const { name, type } = meta[0];

            const hasPriceFields =
                this.inputObj["Deal Price"] !== undefined &&
                this.inputObj["Price"] !== undefined &&
                (this.inputObj["Discount"] !== undefined ||
                    this.inputObj["Discount(%)"] !== undefined) &&
                (type === "String" || type === "Number");

            if (!hasPriceFields) return;

            if (name === "Price") {
                this.calculateDealPriceFromPrice();
            } else if (name === "Discount(%)") {
                this.calculateDealPriceFromPercentage();
            } else if (name === "Discount") {
                this.calculateDealPriceFromAmount();
            }
        },
        calculateDealPriceFromPrice() {
            const discountAmount = this.inputObj["Discount(%)"]
                ? this.inputObj["Price"] * (this.inputObj["Discount(%)"] / 100)
                : this.inputObj["Discount"];

            if (discountAmount) {
                const attrType = this.getAttributeTypeByName("Deal Price");
                this.inputObj["Deal Price"] = this.convertToAttrType(
                    this.inputObj["Price"] - discountAmount,
                    attrType,
                );
                this.updatePriceFieldsInValuesMap();
            }
        },
        calculateDealPriceFromPercentage() {
            const discountAmount =
                this.inputObj["Price"] * (this.inputObj["Discount(%)"] / 100);
            const discountedAmount = this.inputObj["Price"] - discountAmount;

            if (discountedAmount != this.inputObj["Deal Price"]) {
                const attrType = this.getAttributeTypeByName("Deal Price");
                this.inputObj["Deal Price"] = this.convertToAttrType(
                    discountedAmount,
                    attrType,
                );
                delete this.inputObj["Discount"];
                this.updatePriceFieldsInValuesMap();
            }
        },
        calculateDealPriceFromAmount() {
            const discountAmount =
                this.inputObj["Price"] - this.inputObj["Discount"];

            if (discountAmount != this.inputObj["Deal Price"]) {
                const attrType = this.getAttributeTypeByName("Deal Price");
                this.inputObj["Deal Price"] = this.convertToAttrType(
                    discountAmount,
                    attrType,
                );
                delete this.inputObj["Discount(%)"];
                this.updatePriceFieldsInValuesMap();
            }
        },
        updatePriceFieldsInValuesMap() {
            this.valuesMap["Price"] = this.inputObj["Price"];
            this.valuesMap["Deal Price"] = this.inputObj["Deal Price"];
            this.valuesMap["Discount(%)"] = this.inputObj["Discount(%)"];
            this.valuesMap["Discount"] = this.inputObj["Discount"];
        },
        validateStockCountForStandardItem(payload) {
            const inventory = payload.Inventory;
            const isStandard = inventory === "STANDARD_ITEM";
            if (!isStandard) return true;

            const stockCount =
                payload.StockCount !== undefined ? payload.StockCount : null;
            const stockCountNum = Number(stockCount);

            if (
                !stockCount ||
                Number.isNaN(stockCountNum) ||
                stockCountNum <= 0
            ) {
                this.$swal({
                    title: "Error",
                    text: "StockCount must be greater than 0 for STANDARD_ITEM inventory",
                    type: "error",
                });
                return false;
            }

            // For VARIABLE products, also validate within variations if present.
            if (Array.isArray(payload.variations) && payload.variations.length) {
                for (const variant of payload.variations) {
                    const inv =
                        variant?.attributes?.Inventory !== undefined
                            ? variant.attributes.Inventory
                            : inventory;
                    if (inv !== "STANDARD_ITEM") continue;

                    const vStock = variant?.attributes?.StockCount;
                    const vStockNum = Number(vStock);
                    if (!vStock || Number.isNaN(vStockNum) || vStockNum <= 0) {
                        this.$swal({
                            title: "Error",
                            text: "StockCount must be greater than 0 for STANDARD_ITEM inventory",
                            type: "error",
                        });
                        return false;
                    }
                }
            }

            return true;
        },
        async handleSumit() {
            this.inputObj["b2bType"] = `${this.typeB2b.value}`;

            let payload = this.buildBasePayload();
            payload = this.normalizePayloadValues(payload);
            payload = this.applyFallbackValues(payload);
            payload = this.removeInternalFields(payload);
            payload = this.attachPreservedItemFields(payload);
            payload = this.handleAddressLogic(payload);
            if (!this.validateStockCountForStandardItem(payload)) return;

            await this.submitUpdateRequest(payload);
        },
        buildBasePayload() {
            return {
                ...this.valuesMap,
                ...this.inputObj,
            };
        },
        normalizePayloadValues(payload) {
            const allKeys = new Set([
                ...Object.keys(payload),
                ...Object.keys(this.valuesMap),
            ]);

            allKeys.forEach((key) => {
                const value =
                    payload[key] !== undefined
                        ? payload[key]
                        : this.valuesMap[key];

                if (
                    Array.isArray(value) &&
                    value.length > 0 &&
                    value[0]?.value
                ) {
                    payload[key] = value.map((v) => v.value);
                }
            });
            if (
                payload.hasOwnProperty("IsSellable") ||
                this.inputObj.hasOwnProperty("IsSellable")
            ) {
                const isSellable =
                    payload.IsSellable !== undefined
                        ? payload.IsSellable
                        : this.inputObj.IsSellable;
                payload.IsSellable = isSellable ? "TRUE" : "FALSE";
            }

            return payload;
        },
        applyFallbackValues(payload) {
            if (payload["Name"] === "") {
                payload["Name"] = this.itemObj.Name;
            }
            payload.description_summary = payload["Name"];

            return payload;
        },
        removeInternalFields(payload) {
            const fieldsToRemove = [
                "product_summary",
                "updatedAt",
                "createdAt",
                "_id",
                "Title",
                "attributeItems",
                "string_attributes",
                "integer_attributes",
                "itemIndex",
                "tags",
            ];

            fieldsToRemove.forEach((field) => {
                delete payload[field];
            });

            return payload;
        },
        attachPreservedItemFields(payload) {
            const resolvedCatalogId =
                this.itemObj.catalogId || payload.catalogId;
            payload.catalogId = resolvedCatalogId;
            payload.provider = this.itemObj.provider;
            payload.isDeleted = false;
            if (payload["isOffline"]) {
                payload.isOffline = this.itemObj.isOffline;
            } else {
                payload.isOffline = false;
            }
            if (
                this.inputObj["Price"] !== undefined &&
                this.inputObj["Price"] !== null
            ) {
                payload.Price = this.inputObj["Price"];
            }
            payload.images = {
                icon: this.itemObj.product_summary.images.icon,
                smallImage: this.itemObj.product_summary.images.smallImage,
                bigImage: this.itemObj.product_summary.images.bigImage,
            };

            return payload;
        },
        handleAddressLogic(payload) {
            if (!this.isAddresscapture) {
                return payload;
            }

            if (this.addressObj.data) {
                return this.applyNewAddress(payload);
            } else {
                return this.preserveExistingAddress(payload);
            }
        },
        applyNewAddress(payload) {
            const addressFields = Object.keys(this.addressObj.data);

            addressFields.forEach((field) => {
                if (field !== "zip") {
                    payload[field] = this.addressObj.data[field];
                }
            });

            payload.Lng = this.addressObj.Lng;
            payload.Lat = this.addressObj.Lat;
            payload.Address = {
                Lng: payload.Lng,
                Lat: payload.Lat,
                City: payload.City,
                State: payload.State,
                Country: payload.Country,
                Address: this.addressObj.address,
            };
            payload.Area = this.addressObj.address;

            return payload;
        },
        preserveExistingAddress(payload) {
            payload.City = this.itemObj.Address.City;
            payload.Country = this.itemObj.Address.Country;
            payload.State = this.itemObj.Address.State;
            payload.Lat = this.itemObj.Address.Lat;
            payload.Lng = this.itemObj.Address.Lng;
            payload.Address = {
                Lng: payload.Lng,
                Lat: payload.Lat,
                City: payload.City,
                State: payload.State,
                Country: payload.Country,
                Address: this.itemObj.Address.Address,
            };
            payload.Area = payload.Address.Address;

            return payload;
        },
        async submitUpdateRequest(payload) {
            const requestData = {
                id: this.$route.params.id,
                object: payload,
            };

            try {
                await this.$store.dispatch("item/updateItemById", requestData);
                this.$swal({
                    title: "Success",
                    text: "Item has been updated successfully",
                    type: "success",
                });
                this.backNavigate();
            } catch (error) {
                const errorMessage =
                    (error &&
                        error.message &&
                        (error.message.message || error.message)) ||
                    "Item has not been updated!!";
                this.$swal({
                    title: "Error",
                    text: errorMessage,
                    type: "error",
                });
            }
        },
        showImagePicker(selector) {
            this.libraryImageSelector = selector;
            this.showImageSelector = true;
        },

        uploadImageFromSelector(e) {
            const file = e.target.files[0];
            if (!file.type.match("image.*")) {
                this.invalid = true;
                this.$toasted.error("Invalid File format");
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                const image = e.target.result;
                this.image = image;
                this.uploadImage(this.libraryImageSelector, image);
                this.$refs["imageUploader"].value = "";
            };
            reader.readAsDataURL(file);
        },

        setImageFromLibrary(images) {
            this.itemObj.product_summary.images[this.libraryImageSelector] =
                images[this.libraryImageSelector];
            this.libraryImageSelector = "";
            this.showImageSelector = false;
        },

        setAlternateImages(images) {
            this.inputObj.images.alternateImages = images.map((i) => ({
                image: i,
            }));
        },

        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },

        clearCustomToast() {
            Vue.toasted.clear();
        },

        onchangeVarianceData(data) {
            this.inputObj.variations = data;
        },

        changeDefault(val) {
            if (!val) return;

            const updatedStringAttrs = this.attributesMap
                .get("String")
                .map((attr) => {
                    const updatedAttr = { ...attr };
                    const attributeKey = Object.keys(val.attributes)[0];
                    if (attr.attributeName === attributeKey) {
                        updatedAttr.defaultValue = val.attributes[attributeKey];
                    }
                    if (
                        attr.attributeName === "Deal Price" &&
                        val.DealPrice > 0
                    ) {
                        updatedAttr.defaultValue = val.DealPrice;
                    }
                    if (attr.attributeName === "Discount" && val.Discount > 0) {
                        updatedAttr.defaultValue = val.Discount;
                    }
                    if (
                        attr.attributeName === "Discount(%)" &&
                        val.DiscountPercentage > 0
                    ) {
                        updatedAttr.defaultValue = val.DiscountPercentage;
                    }
                    if (attr.attributeName === "Inventory") {
                        updatedAttr.defaultValue = val.Inventory;
                    }
                    if (attr.attributeName === "StockCount") {
                        updatedAttr.defaultValue = val.StockCount;
                    }

                    return updatedAttr;
                });

            const updatedNumberAttrs = this.attributesMap
                .get("Number")
                .map((attr) => {
                    const updatedAttr = { ...attr };

                    if (
                        attr.attributeName === "Deal Price" &&
                        val.DealPrice > 0
                    ) {
                        updatedAttr.defaultValue = val.DealPrice;
                    }

                    if (attr.attributeName === "Price" && val.DealPrice > 0) {
                        updatedAttr.defaultValue = val.Price;
                    }

                    if (attr.attributeName === "Discount") {
                        updatedAttr.defaultValue = val.Discount;
                    }

                    if (
                        attr.attributeName === "Discount(%)" &&
                        val.DiscountPercentage > 0
                    ) {
                        updatedAttr.defaultValue = val.DiscountPercentage;
                    }

                    if (attr.attributeName === "StockCount") {
                        updatedAttr.defaultValue = val.StockCount;
                    }

                    return updatedAttr;
                });

            this.attributesMap = new Map([
                ["String", updatedStringAttrs],
                ["Number", updatedNumberAttrs],
                ["Object", this.attributesMap.get("Object")],
                ["Array", this.attributesMap.get("Array")],
                ["Boolean", this.attributesMap.get("Boolean")],
            ]);
        },

        setActive(i) {
            this.activeIndex = this.activeIndex == i ? -1 : i;
        },

        arrayChange(data) {
            const { index, type, e, fieldName, meta, value, action, arrObj } =
                data;
            let updateDoc = { ...this.valuesMap };
            let temp = this.valuesMap;
            let parent = temp;
            let path = "";
            for (let i = 0; i < meta.length; i++) {
                const item = meta[i];
                const { type, name } = item;

                if (
                    ["Object", "String", "Number", "Array", "Boolean"].includes(
                        type,
                    )
                ) {
                    parent = temp;
                    path = item.name;
                    temp = temp[item.name];
                }
            }
            switch (type) {
                case "check": {
                    this.$set(temp[index], "checked", e.target.checked);
                    break;
                }
                case "select": {
                    this.$set(parent, fieldName, e);
                    break;
                }
                case "radio": {
                    this.$set(parent, fieldName, e);
                    break;
                }
            }
            if (arrObj === true) {
                switch (action) {
                    case "change": {
                        this.$set(
                            parent,
                            path,
                            temp.map((item, idx) =>
                                idx === index
                                    ? { ...item, [fieldName]: e }
                                    : item,
                            ),
                        );
                        break;
                    }
                    case "add": {
                        const defaultObject = {};
                        const keys = Object.keys(temp[0]);
                        keys.forEach((key) => {
                            defaultObject[key] = "";
                        });
                        this.$set(parent, path, temp.concat([defaultObject]));
                        break;
                    }
                    case "remove": {
                        temp.splice(index, 1);
                        break;
                    }
                }
            }
        },

        backNavigate() {
            if (this.userRole === "Tenant") {
                this.$router.push({
                    name: "partner-item",
                    params: { id: this.partnerAllData._id },
                });
            } else {
                this.$router.push("/item");
            }
        },

        ...mapActions({
            getImageLibraryList: "catalog/listImageLibrary",
            createLibrary: "catalog/createImageLibrary",
        }),
    },

    async mounted() {
        this.loading = true;

        try {
            await this.loadItem();
            await this.getImageLibraryList(this.itemObj.catalogId);
        } finally {
            this.loading = false;
        }
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.card-wrap {
    border: none !important;
    box-shadow: 0px 0px 10px 1px rgb(235, 235, 235) !important;
    border-radius: 1px !important;
}
.wrap {
    margin: 10px;
}
.head {
    font-size: 1.2em;
    font-weight: 900;
}
.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}
.border-blue {
    border: 4px solid lightskyblue;
}
.card-title {
    font-size: 1em;
    font-weight: 800;
    padding-left: 14px;
    padding-top: 10px;
}
</style>
